export default __webpack_public_path__ + "static/media/wxusd-logo-ellipse-transparent-260x260.885f4a9c.svg";